import React, { useContext, useState, useEffect, useRef } from 'react'

// import CustomTable from '../../components/molecules/CustomTable'
// import CustomSearch from '../../components/molecules/CustomSearch'

// import FullScreenPopup from '../../components/organisms/FullScreenPopup'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Reorder from 'react-reorder'
import move from 'lodash-move'
import PropTypes from 'prop-types'
import { Button, Dialog } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Loaders from '@/product/components/molecules/Loaders'

import SettingContext from '@/product/context/setting/settingContext'
import CloseIcon from '@mui/icons-material/Close'
import CustomCommonContext from '@/custom/context/common/commonContext'
import Slide from '@mui/material/Slide'
import authContext from '@/product/context/auth/authContext'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const DropdownValueManage = (props) => {
    const { alldata_all_dropdown } = useContext(CustomCommonContext)
    const [reload, setReload] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const settingcontext = useContext(SettingContext)
    const { user } = useContext(authContext)
    const [users, setUsers] = useState(0)
    const [sourceData, setSourceData] = useState([])
    const saveRequestPending = useRef(false)

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const validationArrayDrop = Yup.object({
        source_value: Yup.string().required('Required!'),
        // value: Yup.boolean().when('diff_value', {
        //     is: true,
        //     then: Yup.string().required('Required!'),
        // }),
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'cigar_source') {
                setSourceData(...search_fetch_data?.records)
            }
        }
    }, [alldata_all_dropdown, props])

    useEffect(() => {
        if (props?.data?.data && props?.data?.status == 'edit') {
            searchTableFetch(
                {
                    page: 1,
                    limit: 20,
                    order: '',

                    primaryTable: 'cigar_source',
                    filters: {
                        active: {
                            value: props?.data?.data,
                            type: 'in',
                            field: 'cs.id',
                        },
                    },
                },
                'cigar_source'
            )
        }
    }, [props?.data?.data])

    useEffect(() => {
        setUsers(user?.emp_email)
    }, [user])
    const data = props.data

    const toggleFullScreenDropPopup = props.function

    const formikDrop = useFormik({
        initialValues: {
            id: 0,
            source_value: '',
            zh_label: '',

            added_by: users,
            global_publisher: true,
            en_label: '',

            table: 'cigar_source',
            updateCigarSource: true,
        },
        validateOnBlur: false,
        validationSchema: validationArrayDrop,
        onSubmit: async (values) => {
            if (saveRequestPending.current) {
                return
            }
            saveRequestPending.current = true
            try {
                await searchTableAction(
                    {
                        ...values,
                        added_by: users,
                        global_publisher: true,
                    },
                    false,
                    'cigar_source'
                )
            } finally {
                saveRequestPending.current = false
            }
        },
    })

    const resetFromDrop = () => {
        formikDrop.setFieldValue('id', 0)
        formikDrop.setFieldValue('source_value', '')
        formikDrop.setFieldValue('en_label', '')
        formikDrop.setFieldValue('zh_label', '')
        formikDrop.handleReset()
        setReload(!reload)
    }

    useEffect(() => {
        if (data.status === 'edit' && sourceData?.id) {
            formikDrop.setFieldValue('id', sourceData.id)
            const template = sourceData

            formikDrop.setFieldValue('source_value', template.source_value)

            formikDrop.setFieldValue('zh_label', template?.zh_label || '')
            formikDrop.setFieldValue('en_label', template?.en_label || '')

            setIsLoading(false)
        } else {
            resetFromDrop()
            setIsLoading(false)
        }
    }, [sourceData])

    useEffect(() => {
        if (props.show_order) {
            formikDrop.setFieldValue('show_order', props.show_order)
        }
    }, [props.show_order])

    useEffect(() => {
        if (props.name) {
            formikDrop.setFieldValue('variable', props.name)
            setReload(!reload)
        }
    }, [props.name])

    const detailsDrop = {
        formik: formikDrop,
        data: [
            {
                label: 'Source Value',
                placeholder: 'Cigar Source',
                type: 'text',
                class: 'col-sm-12 col-12',
                // class: `col-sm-12 col-12 ${props.diff_value ? '' : 'd-none'}`,
                name: 'source_value',
            },
            {
                label: 'English Text',
                placeholder: 'Text To Display User',
                type: 'text',
                class: 'col-sm-12 col-12',
                field: 'en_label',
                // class: `col-sm-12 col-12 ${
                //     props.custom_language ? '' : 'd-none'
                // }`,
                name: 'en_label',
            },
            {
                label: 'Mandarin Text',
                placeholder: 'Mandarin Text',
                type: 'text',
                class: 'col-sm-12 col-12',
                field: 'zh_label',
                // class: `col-sm-12 col-12 ${
                //     props.custom_language ? '' : 'd-none'
                // }`,
                name: 'zh_label',
            },
        ],
    }

    return (
        <>
            <Dialog
                className="dropdownManageModal"
                open={data.popup}
                onClose={() => {
                    if (!saveRequestPending.current) {
                        toggleFullScreenDropPopup(false, 'new', 0)
                    }
                }}
                TransitionComponent={Transition}
            >
                <>
                    <Button
                        className="closeIcon"
                        disabled={formikDrop.isSubmitting}
                        onClick={() =>
                            toggleFullScreenDropPopup(false, 'new', 0)
                        }
                    >
                        <CloseIcon />
                    </Button>
                    <h2 className="ddmTitle">
                        {data.status === 'new'
                            ? props.dropDownName
                                ? props.dropDownName
                                : `Add a new dropdown value`
                            : props.dropDownNameEdit
                            ? props.dropDownNameEdit
                            : 'Edit dropdown value'}
                    </h2>
                    <form
                        onSubmit={formikDrop.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div className="row">{mapData(detailsDrop)}</div>
                        <div className="actionButton d-flex justify-content-center align-items-center">
                            <PrimaryButton
                                id="dynamic_drop_submit"
                                type="submit"
                                label="Submit"
                                disabled={formikDrop.isSubmitting}
                            />
                        </div>
                    </form>
                </>
            </Dialog>
        </>
    )
}

export default DropdownValueManage
